const filterSettings = t => {
  const FILTER = {
    type: {
      label: t('Fahrzeugtyp'),
      name: 'type',
    },
    extras: {
      label: t('Extras'),
      name: 'extras',
      pkw: [
        {label: t('Anhängerkupplung'), name: 'trailerHitch'},
        {label: t('Navigation'), name: 'navigation'},
        {label: t('Diesel'), name: 'diesel'},
        {label: t('Automatik'), name: 'automatic'},
      ],
      lkw: [
        {label: t('Anhängerkupplung'), name: 'trailerHitch'},
        {label: t('Navigation'), name: 'navigation'},
        {label: t('Automatik'), name: 'automatic'},
      ],
    },
    age: {
      label: t('Alter'),
      name: 'minAge',
      pkw: [
        {label: t('25+'), name: 25},
        {label: t('23-24'), name: 23},
        {label: t('21-22'), name: 21},
        {label: t('18-20'), name: 18},
      ],
    },
    licence: {
      label: t('Führerschein'),
      name: 'licence',
      lkw: [
        {label: t('B (BIS 3,49TO)'), name: 'B'},
        {label: t('C1 / 3 (BIS 7,49TO)'), name: 'C1'},
        {label: t('C / 2 (BIS 12TO)'), name: 'C'},
      ],
    },
    features: {
      pkw: {
        premium: {
          label: t('Premium'),
          name: 'premiumGroup',
          iconName: 'star',
        },
        electric: {
          label: t('E-Fahrzeuge'),
          name: 'electro',
          iconName: 'electro',
        },
        payment: {
          label: t('Nur EC-Karte'),
          name: 'paymentEcOnly',
          iconName: 'creditcard',
        },
      },
      lkw: {
        lifting: {
          label: t('Hebebühne'),
          name: 'liftingPlatform',
          iconName: 'liftingPlatform',
        },
      },
    },
  };

  return FILTER;
};

export default filterSettings;
